module.exports = __webpack_public_path__ + "static/media/default.a37ff943.png";